import { PATH_NAMES } from '../constants';

export const selectTreatmentPath = shopName => PATH_NAMES.SELECT_TREATMENT.replace(/:\w+/, shopName.toLowerCase().trim().replace(/(\s+)/g, '-'));

export const config = {
  firstPageHash: '#landing',
  shopsNextPath: selectTreatmentPath,
  selectTreatmentNextPath: PATH_NAMES.SELECT_DATE,
  selectDatePrevPath: selectTreatmentPath,
  aboutYouPrevPath: PATH_NAMES.SELECT_DATE,
  reviewPrevPath: PATH_NAMES.ABOUT_YOU,
};
